function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgOutputPapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "DOC-copy_x5F_quantity_x5F_24_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccccff"
    },
    d: "M20,6.5C20,6.3,19.8,6,19.5,6h-11C8.3,6,8,6.3,8,6.5v15C8,21.8,8.3,22,8.5,22H13c0.5,0,0.9-0.2,1.3-0.5l5.2-5.2 C19.9,16,20,15.5,20,15V6.5z M14,16v4c0,0.3-0.1,0.5-0.3,0.7C13.6,20.9,13.3,21,13,21H9V7h10v8c0,0.3-0.1,0.5-0.3,0.7 C18.6,15.9,18.3,16,18,16H14z M7,20H6.5C6.3,20,6,19.8,6,19.5v-15C6,4.3,6.3,4,6.5,4h11C17.8,4,18,4.3,18,4.5V5H7V20z M5,18H4.5 C4.3,18,4,17.8,4,17.5v-15C4,2.3,4.3,2,4.5,2h11C15.8,2,16,2.3,16,2.5V3H5V18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOutputPapers);
export default __webpack_public_path__ + "static/media/img_OutputPapers.1dada33d70f55ffaed799655ebb66bd7.svg";
export { ForwardRef as ReactComponent };